import React, {useEffect, useRef, useState} from "react";
import OrderLine from "./OrderLine";
import {FileSpreadsheet, PrinterFill} from 'react-bootstrap-icons';
import {APIBASE, RELOADORDERSALLMINUTES} from "../../config/Pfalzmarkt.config";
import axios from "axios";
import {formatDate} from "../../service/general";
import {useStore} from "../../store/store";
import ShowOrderDIrection from "./ShowOrderDIrection";

export default function Bestellungen() {
    const [globalState, dispatch] = useStore();
    const [orders, setOrders] = useState([]);
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    const currentDate = new Date();
    const [sort, setSort] = useState({});
    const [showmultiPrint, setShowmultiPrint] = useState(false);
    const [orderUrl, setOrderUrl] = useState("api/bestellungen");
    const intervalId = useRef(null);

    function mapData(data) {
        setOrders(data);
    }

    const printPalettenBs = async () => {
        const checkboxes = document.querySelectorAll('#allOrders input[type="checkbox"]');
        const documents = [];
        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                documents.push(checkbox.value)
            }
        }
        try {
            axios({
                method: 'post',
                url: APIBASE + 'api/bestellungen/concatPalettenBs',
                rejectUnauthorized: false,
                headers: header,
                responseType: 'arraybuffer',
                data: documents,
            }).then(result => {
                const data = result.data;

                const bufferArray = new Uint8Array(data).buffer;
                const blob = new Blob([bufferArray], {
                    type: "application/pdf", // Specify the MIME type of the file
                });
                const url = URL.createObjectURL(blob);
                const printWindow = window.open(url, '_blank');

                if (printWindow) {
                    setTimeout(() => {

                        printWindow.print();
                        try {
                            printWindow.onmouseout = () => {
                                printWindow.close();
                            }
                        } catch (e) {
//
                        }

                    }, 100);

                }
            });

        } catch (err) {
            console.log(err.message || 'Something went wrong!');

        }


    }

    const [orderTime, setOrderTime] = useState(1);

    const fetchOrders = async () => {

        const header = "Authorization: Bearer " + localStorage.getItem("token");
        try {
            const response = await axios.get(
                APIBASE + orderUrl, {headers: header}
            );
            const data = await response.data;
            mapData(data);

        } catch (err) {
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
            }
            console.log(err.message); // Todo: Errorhandling
            //        }
        }
    }


    async function fetchBestellungenAsExcel() {
        try {
            const response = await axios.get(
                APIBASE + 'api/bestellungenAsExcel',
                {headers: header, responseType: 'arraybuffer'});
            const data = await response.data;
            const bufferArray = new Uint8Array(data).buffer;
            const blob = new Blob([bufferArray], {
                type: "application/vnd.ms-excel", // Specify the MIME type of the file
            });

            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "bestellungen" + formatDate(currentDate) + ".xlsx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.log(err);
            console.log(err.message); // Todo: Errorhandling

        }
    }

    clearInterval(intervalId.current);
    intervalId.current = setInterval(function () {
        fetchOrders();
    }, RELOADORDERSALLMINUTES * 1000 * 60);

    useEffect(() => {
        fetchOrders();
    }, [globalState.token, sort]);


    function changeOrder(state) {
        setShowmultiPrint(false);
        switch (state) {
            case 'today':
                setOrderTime(1);
                break;
            case 'tomorrow':
                setOrderTime(2);
                break;
            case 'later':
                setOrderTime(3);
                break;
            case 'archive':
                setOrderTime(4);
                break;
            default:
                setOrderTime(1);
        }
    }

    function changeSort(sortField) {
        if (sort.field === sortField) {
            let sortDirection = sort.direction === 'ASC' ? "DESC" : "ASC";
            setSort({field: sortField, direction: sortDirection});
            setOrderUrl('api/bestellungen/' + sortField + '_' + sortDirection);
        } else {
            setSort({field: sortField, direction: 'ASC'});
            setOrderUrl('api/bestellungen/' + sortField + '_ASC');
        }
    }

    return (
        <>
            <ul className="nav nav-pills nav-fill">
                <li className="nav-item" onClick={() => changeOrder('today')}>
                    <p className={"nav-link " + (orderTime === 1 ? 'active' : '')}>Heute({orders.today && orders.today.length})</p>
                </li>
                <li className="nav-item" onClick={() => changeOrder('tomorrow')}>
                    <p className={"nav-link " + (orderTime === 2 ? 'active' : '')}>Morgen({orders.tomorrow && orders.tomorrow.length})</p>
                </li>
                <li className="nav-item" onClick={() => changeOrder('later')}>
                    <p className={"nav-link " + (orderTime === 3 ? 'active' : '')}>Später({orders.later && orders.later.length})</p>
                </li>
                <li className="nav-item" onClick={() => changeOrder('archive')}>
                    <p className={"nav-link " + (orderTime === 4 ? 'active' : '')}>Archiv({orders.archive && orders.archive.length})</p>
                </li>
                <li className="nav-item">
                    <span className="p-1"><PrinterFill onClick={() => window.print()}/></span>
                    <span className="p-1"><FileSpreadsheet onClick={() => fetchBestellungenAsExcel()}/></span>
                </li>
            </ul>
            <p>Zum Sortieren bitte auf die Spaltenüberschrift klicken. {showmultiPrint &&
                <button type="button" className="btn" style={{backgroundColor: "#0d6efd"}}
                        onClick={() => printPalettenBs()}>Alle markierten Zeilen drucken </button>}</p>
            <table className="table">
                <thead>
                <tr>
                    <th scope="col" onClick={() => changeSort(0)}><ShowOrderDIrection sort={sort}
                                                                                      current="0"/> Beschreibung
                    </th>
                    <th scope="col" onClick={() => changeSort(1)}><ShowOrderDIrection sort={sort} current="1"/>Kunde
                    </th>
                    <th scope="col" onClick={() => changeSort(2)}><ShowOrderDIrection sort={sort} current="2"/>Menge
                    </th>
                    <th scope="col" onClick={() => changeSort(3)}><ShowOrderDIrection sort={sort} current="3"/>Leergut
                    </th>
                    <th scope="col" onClick={() => changeSort(6)}><ShowOrderDIrection sort={sort} current="6"/>Qualitätssiegel
                    </th>
                    <th scope="col" onClick={() => changeSort(4)}><ShowOrderDIrection sort={sort} current="4"/>Hinweis
                    </th>
                    <th scope="col" onClick={() => changeSort(5)}><ShowOrderDIrection sort={sort} current="5"/>Datum
                    </th>
                </tr>
                </thead>
                {orderTime === 1 && orders.today &&
                    <OrderLine orders={orders.today} setShowmultiPrint={setShowmultiPrint}/>
                }
                {orderTime === 2 &&
                    <OrderLine orders={orders.tomorrow} setShowmultiPrint={setShowmultiPrint}/>
                }
                {orderTime === 3 &&
                    <OrderLine orders={orders.later} setShowmultiPrint={setShowmultiPrint}/>
                }
                {orderTime === 4 &&
                    <OrderLine orders={orders.archive}/>
                }
            </table>
        </>
    )
}